import React from "react"
import classNames from "classnames";
import Image from "../image";
import Video from "../elements/video";
import ButtonLink from "../elements/button-link"
import { getButtonAppearance } from "@/utils/button"

const FeatureRowsGroup = ({ data }) => {
  return (
    <div className="container flex flex-col">
      {data.features.map((feature, index) => (
        <div
          className={classNames(
            // Common classes
            "flex flex-col justify-start md:justify-between md:items-center sm:flex-col-reverse",
            {
              "lg:flex-row bg-gray-100": index % 2 === 0,
              "lg:flex-row-reverse bg-gray-200": index % 2 === 1,
            }
          )}
          key={feature.id}
        >
          {/* Text section */}
          <div className="w-full lg:w-6/12 text-lg p-16 md:p-32 lg:py-10 lg:px-20 xl:px-28 xl2:px-48">
            <h3 className="xl2:text-5xl xl:text-4xl lg:text-3xl sm:text-2xl sm:font-semibold">{feature.title}</h3>
            <h3 className="xl2:text-4xl xl:text-3xl lg:text-2xl sm:text-xl sm:font-semibold mt-4">{feature.subtitle}</h3>
            <p className="my-6">{feature.description}</p>
            <div className="md:w-4/12">
              <ButtonLink
                button={feature.link}
                appearance={getButtonAppearance(feature.link.type, "light")}
                key={feature.link.id}
              />
            </div>
          </div>
          {/* Media section */}
          <div className="w-full sm:9/12 lg:w-6/12 max-h-full">
            {/* Images */}
            {feature.media.mime.startsWith("image") && (
              <Image media={feature.media} className="w-full h-auto" />
            )}
            {/* Videos */}
            {feature.media.mime.startsWith("video") && (
              <Video
                media={feature.media}
                className="w-full h-auto"
                autoPlay
                controls={false}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeatureRowsGroup;
